export default __webpack_public_path__ + "strongher-devices@2x.64adc98e.png";